import React from "react";
import { useTranslation } from "react-i18next";

import * as sc from "./styles";

const Terms = () => {
  const { t } = useTranslation();

  return (
    <sc.Terms>
      <h4>{t("Stock image use guidelines")}</h4>

      <ul>
        <li>
          {t("Content is for digital use within TalentBait only and may not be used for printing.")}
        </li>
        <li>{t("You may not use the content as a trademark for a business.")}</li>
        <li>
          {t(
            "You may not portray a person in a way that may be offensive, including: in connection with adult-oriented services or ads for dating services; in connection with the promotion of tobacco products; in connection with political endorsements; with pornographic, defamatory, unlawful, offensive or immoral content; and as suffering from, or being treated for, a physical or mental ailment."
          )}
        </li>
        <li>
          {t(
            "You may only use the content in campaigns and content created on TalentBait, and not with other website or content services."
          )}
        </li>
      </ul>
    </sc.Terms>
  );
};

export default Terms;
